import { Component, Inject, Optional } from '@angular/core';
import { HotToastRef } from '@ngneat/hot-toast';
import { AlertType } from '@nft-folks/interfaces';

export interface NotificationDataType {
  message: string;
  alertType: AlertType;
}

@Component({
  standalone: false,
  selector: 'nft-folks-notification-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss'],
})
export class NotificationToastComponent {
  constructor(
    @Optional() @Inject(HotToastRef) public toastRef: HotToastRef<NotificationDataType>,
  ) {}

  get message() {
    return this.toastRef.data.message;
  }
}
